"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = __importDefault(require("../Icon/Icon"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const CloseSmall_1 = __importDefault(require("../Icon/Icons/components/CloseSmall"));
const themes_1 = require("../../services/themes");
const function_utils_1 = require("../../utils/function-utils");
const colors_vars_map_1 = require("../../utils/colors-vars-map");
const Avatar_1 = __importDefault(require("../Avatar/Avatar"));
const IconButton_1 = __importDefault(require("../IconButton/IconButton"));
const test_utils_1 = require("../../utils/test-utils");
const ChipsConstants_1 = require("./ChipsConstants");
const AvatarConstants_1 = require("../Avatar/AvatarConstants");
const Chips_module_scss_1 = __importDefault(require("./Chips.module.scss"));
const Chips = (0, react_1.forwardRef)(({ className, id, label, leftIcon, rightIcon, leftAvatar, rightAvatar, disabled, readOnly, allowTextSelection, color, iconSize, onDelete, onMouseDown, noAnimation, dataTestId }, ref) => {
    const overrideDataTestId = dataTestId || (0, test_utils_1.getTestId)(test_utils_1.ELEMENT_TYPES.CHIP, id);
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const backgroundColorStyle = (0, react_1.useMemo)(() => {
        return { backgroundColor: disabled ? (0, themes_1.getCSSVar)("disabled-background-color") : (0, colors_vars_map_1.getElementColor)(color, true) };
    }, [disabled, color]);
    const onDeleteCallback = (0, react_1.useCallback)((e) => {
        if (onDelete) {
            onDelete(id, e);
        }
    }, [id, onDelete]);
    const hasCloseButton = !readOnly && !disabled;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)(Chips_module_scss_1.default.chips, "chips--wrapper", className, {
            disabled,
            [Chips_module_scss_1.default.withClose]: hasCloseButton,
            [Chips_module_scss_1.default.noAnimation]: noAnimation,
            [Chips_module_scss_1.default.withUserSelect]: allowTextSelection
        }), id: id, style: backgroundColorStyle, onMouseDown: onMouseDown, "data-testid": overrideDataTestId }, { children: [leftAvatar ? ((0, jsx_runtime_1.jsx)(Avatar_1.default, { withoutBorder: true, className: (0, classnames_1.default)(Chips_module_scss_1.default.avatar, Chips_module_scss_1.default.left), customSize: 16, src: leftAvatar, type: AvatarConstants_1.AvatarType.IMG }, id)) : null, leftIcon ? ((0, jsx_runtime_1.jsx)(Icon_1.default, { className: (0, classnames_1.default)(Chips_module_scss_1.default.icon, Chips_module_scss_1.default.left), iconType: Icon_1.default.type.ICON_FONT, clickable: false, icon: leftIcon, iconSize: iconSize, ignoreFocusStyle: true })) : null, (0, jsx_runtime_1.jsx)("div", Object.assign({ className: Chips_module_scss_1.default.label }, { children: label })), rightIcon ? ((0, jsx_runtime_1.jsx)(Icon_1.default, { className: (0, classnames_1.default)(Chips_module_scss_1.default.icon, Chips_module_scss_1.default.right), iconType: Icon_1.default.type.ICON_FONT, clickable: false, icon: rightIcon, iconSize: iconSize, ignoreFocusStyle: true })) : null, rightAvatar ? ((0, jsx_runtime_1.jsx)(Avatar_1.default, { withoutBorder: true, className: (0, classnames_1.default)(Chips_module_scss_1.default.avatar, Chips_module_scss_1.default.right), customSize: 16, src: rightAvatar, type: AvatarConstants_1.AvatarType.IMG }, id)) : null, hasCloseButton && ((0, jsx_runtime_1.jsx)(IconButton_1.default, { size: ChipsConstants_1.ChipsSize.XXS, color: IconButton_1.default.colors.ON_PRIMARY_COLOR, className: (0, classnames_1.default)(Chips_module_scss_1.default.icon, Chips_module_scss_1.default.close), ariaLabel: "Remove", hideTooltip: true, icon: CloseSmall_1.default, onClick: onDeleteCallback, dataTestId: `${overrideDataTestId}-close` }))] })));
});
Object.assign(Chips, {
    sizes: ChipsConstants_1.ChipsSize,
    colors: colors_vars_map_1.elementColorsNames
});
Chips.defaultProps = {
    className: "",
    id: "",
    label: "",
    disabled: false,
    dataTestId: undefined,
    readOnly: false,
    rightIcon: null,
    leftIcon: null,
    leftAvatar: null,
    rightAvatar: null,
    color: colors_vars_map_1.elementColorsNames.PRIMARY,
    iconSize: 16,
    onDelete: (_id, _e) => { },
    onMouseDown: function_utils_1.NOOP,
    noAnimation: false,
    allowTextSelection: false
};
exports.default = Chips;
